import BaseAction from './BaseAction.js';
import {setNumberOfPatterns} from 'actions/index.js';

class DeletePatternAction extends BaseAction {
    constructor(sequencerEngine) {
        super(sequencerEngine);
    }

    execute({patternNumber}) {
        let patterns = this.sequencerEngine.tracks
            .map(track => track.patterns[patternNumber]);

        this.sequencerEngine.deletePattern(patternNumber);
        return {patterns: patterns, patternNumber: patternNumber};
    }

    undo(action) {
        // add back the pattern
        let patterns = action.payload.patterns;
        let patternNumber = action.payload.patternNumber;
        // add it back in

        for (let trackNumber in patterns) {
            let track = this.sequencerEngine.tracks[trackNumber];
            let newTrackPatterns = track.patterns.slice(0, patternNumber)
                .concat([patterns[trackNumber]])
                .concat(track.patterns.slice(patternNumber));
            track.patterns = newTrackPatterns;
            track.switchToPattern(track.currentPattern);
            track.updateSteps();
        }
        this.sequencerEngine.store.dispatch(
            setNumberOfPatterns(this.sequencerEngine.numberOfPatterns()));
    }
}

export default DeletePatternAction;
